<template>
  <section class="claim-banner">
    <div class="claim-row">
      <div class="info">
        <p>{{ t('promo.daily.bannerLabel') }}</p>
        <strong>{{ formattedAmount }}</strong>
      </div>
      <button
        type="button"
        :class="{ 'is-loading': loading }"
        :disabled="amount <= 0 || loading"
        @click="emit('claim')"
      >
        {{ amount > 0 ? t('promo.daily.claimAllButton') : t('promo.daily.claimedOutButton') }}
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
import { formatBaseAmt } from '~/utils/transfer/money'

const props = defineProps<{
  amount: number
  /** 领取请求在途：按钮禁用并保持主色，避免闪成灰色 */
  loading?: boolean
}>()
const emit = defineEmits<{ claim: [] }>()

const { t } = useI18n()
const userStore = useUserStore()
const formattedAmount = computed(() => formatBaseAmt(props.amount, userStore.baseCurrency))
</script>

<style scoped lang="scss">
.claim-banner {
  margin: 12px 14px;
  padding: 16px;
  border-radius: 18px;
  background: linear-gradient(
    135deg,
    rgba(var(--primary-rgb), 0.22),
    rgba(var(--primary2-rgb), 0.12)
  );
  border: 1px solid rgba(var(--primary-rgb), 0.3);
}

.claim-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info p {
  font-size: 12px;
  color: var(--muted);
}

.info strong {
  display: block;
  font-size: 28px;
  font-weight: 900;
  color: var(--primary);
  margin-top: 2px;
}

.claim-banner button {
  padding: 11px 20px;
  border-radius: var(--r-md);
  background: var(--primary);
  color: #fff;
  font-weight: 800;
  font-size: 14px;
  box-shadow: var(--btn-glow);
}

.claim-banner button:disabled {
  background: var(--surface2);
  color: var(--muted);
  box-shadow: none;
  cursor: default;
}

.claim-banner button.is-loading:disabled {
  background: var(--primary);
  color: #fff;
  box-shadow: var(--btn-glow);
  opacity: 0.65;
}
</style>
